import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import isToday from 'dayjs/plugin/isToday';
import isBetween from 'dayjs/plugin/isBetween';
import moment from 'moment-timezone';

import { DATE_12_HOUR_NO_LEADING_ZERO } from 'constants/dateTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isToday);
dayjs.extend(isBetween);

export const timeSort = (a, b) => dayjs(a).unix() - dayjs(b).unix();

export function timeZoneReverseOffset(offset) {
  // This needs to shift the inverse of the utc offset
  // eg. EST = -5, shift by +5 hours
  // 12:00am - 11:59pm February 10th -> Eastern
  // 5:00am February 10th - 4:59pm February 11th UTC
  if (Math.sign(offset) === 1) {
    return -Math.abs(offset);
  }

  return Math.abs(offset);
}

export function dateToUTC(customRange, startOffset, endOffset) {
  // This needs to shift the inverse of the utc offset
  // eg. EST = -5, shift by +5 hours
  // 12:00am - 11:59pm February 10th -> Eastern
  // 5:00am February 10th - 4:59pm February 11th UTC
  const { start, end } = customRange;

  return {
    start: moment
      .utc(start)
      .utcOffset(timeZoneReverseOffset(startOffset))
      .format('YYYY-MM-DDTHH:mm:ss'),
    end: moment.utc(end).utcOffset(timeZoneReverseOffset(endOffset)).format('YYYY-MM-DDTHH:mm:ss'),
  };
}

export const timeZoneOffset = (selectedTimezone, date) =>
  dayjs(date).tz(selectedTimezone).utcOffset();

export const formatTimeInHoursAndMinutes = (minutes, includePaused = false) => {
  const hours = Math.floor(minutes / 60);
  const leftoverMinutes = Math.floor(minutes % 60);
  const pausedText = includePaused ? ' paused' : '';

  if (!hours && !leftoverMinutes) {
    return `0 hr${pausedText}`;
  }
  if (!hours) {
    return `${leftoverMinutes} min${pausedText}`;
  }
  if (!leftoverMinutes) {
    return `${hours} hr${pausedText}`;
  }
  return `${hours} hr and ${leftoverMinutes} min${pausedText}`;
};

/**
 * Formats date and time to always display: "1:30 PM, 10/31/2023"
 * Updated to always show full date format for better clarity
 *
 * @param {dayjs.Dayjs | null} dateTime - The Date object to be formatted
 *   (should already be timezone-converted)
 */
export function formatDateWithDayjs(dateTime) {
  if (dateTime === null) {
    return '';
  }

  return dateTime.format(DATE_12_HOUR_NO_LEADING_ZERO);
}
